import { render, staticRenderFns } from "./SheriffElevadorResponsiveImage.vue?vue&type=template&id=6f37dae0&"
import script from "./SheriffElevadorResponsiveImage.vue?vue&type=script&lang=js&"
export * from "./SheriffElevadorResponsiveImage.vue?vue&type=script&lang=js&"
import style0 from "./SheriffElevadorResponsiveImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SheriffElevadorResponsiveImage.vue"
export default component.exports